import {useEffect} from "react";

let observer = null;

// Fades `.pb-reveal` elements in the first time they scroll into view. Elements already on
// screen are shown straight away. Safe to call after every render that adds new cards.
const useScrollReveal = (deps = []) => {
    useEffect(() => {
        if (!('IntersectionObserver' in window)) {
            document.querySelectorAll('.pb-reveal').forEach(el => el.classList.add('pb-in'));
            return;
        }
        if (!observer) {
            observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;
                    entry.target.classList.add('pb-in');
                    observer.unobserve(entry.target);
                });
            }, {rootMargin: '0px 0px -12% 0px', threshold: 0.08});
        }
        document.querySelectorAll('.pb-reveal:not([data-pb-seen])').forEach(el => {
            el.setAttribute('data-pb-seen', '');
            if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add('pb-in');
            else observer.observe(el);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

export default useScrollReveal;
